import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { LOGO_URL } from "../lib/brand";
import { formatApiErrorDetail } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const redirect = params.get("redirect") || "/";
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const user = await login(form.email, form.password);
      toast.success(`Bienvenido, ${user.name}`);
      navigate(user.role === "admin" ? "/admin" : redirect);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mx-auto flex max-w-md flex-col px-6 py-16">
      <div className="mb-6 text-center">
        <img src={LOGO_URL} alt="VALORA" className="mx-auto h-14 w-auto object-contain" />
        <h1 className="mt-6 font-display text-2xl font-extrabold text-brand-navy">Inicia sesión</h1>
        <p className="mt-1 text-sm text-slate-500">Accede a tus certificaciones VALORA</p>
      </div>

      <form onSubmit={submit} className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
        {error && <div className="mb-4 rounded-lg bg-rose-50 p-3 text-sm text-rose-600">{error}</div>}
        <label className="mb-1 block text-sm font-semibold text-slate-700">Correo electrónico</label>
        <input
          data-testid="login-email-input"
          type="email"
          required
          value={form.email}
          onChange={(e) => setForm({ ...form, email: e.target.value })}
          className="mb-4 w-full rounded-xl border border-slate-200 px-4 py-3 text-sm outline-none focus:border-brand-forest"
        />
        <label className="mb-1 block text-sm font-semibold text-slate-700">Contraseña</label>
        <input
          data-testid="login-password-input"
          type="password"
          required
          value={form.password}
          onChange={(e) => setForm({ ...form, password: e.target.value })}
          className="mb-6 w-full rounded-xl border border-slate-200 px-4 py-3 text-sm outline-none focus:border-brand-forest"
        />
        <button
          data-testid="login-submit-button"
          disabled={loading}
          className="w-full rounded-xl brand-navy py-3.5 text-sm font-bold text-white transition-transform hover:scale-[1.02] disabled:opacity-60"
        >
          {loading ? "Ingresando…" : "Ingresar"}
        </button>
      </form>

      <p className="mt-5 text-center text-sm text-slate-500">
        ¿No tienes cuenta?{" "}
        <Link to="/registro" className="font-bold text-brand-forest">Regístrate aquí</Link>
      </p>
    </div>
  );
}
